import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AdminComponent } from './theme/layout/admin/admin.component';
import { AuthComponent } from './theme/layout/auth/auth.component';
import { AuthenticationGuardService } from './backoffice-auth/auth-guard.service';

const routes: Routes = [
	{
		path: '',
		component: AdminComponent,
		children: [
			{
				path: '',
				redirectTo: 'dashboard',
				pathMatch: 'full'
			},
			{
				path: 'dashboard',
				loadChildren: () => import('./content/pages/dashboard/dashboard.module').then(module => module.DashboardModule)
			},
			{
				path: 'download',
				loadChildren: () => import('./content/pages/download/download.module').then(module => module.DownloadModule),
				data: {
					types: ['admin', 'company']
				}
			},
			{
				path: 'list',
				loadChildren: () => import('./content/pages/list/list.module').then(module => module.ListModule),
				data: {
					types: ['admin'],
					aclFeatures: ['admin.list.section']
				}
			},
			{
				path: 'company',
				loadChildren: () => import('./content/pages/company/company.module').then(module => module.CompanyModule),
				data: {
					aclFeatures: ['companies.section']
				}
			},
			{
				path: 'consultant',
				loadChildren: () => import('./content/pages/consultant/consultant.module').then(module => module.ConsultantModule),
				data: {
					aclFeatures: ['admin.consultants.section']
				}
			},
			{
				path: 'user',
				loadChildren: () => import('./content/pages/user/user.module').then(module => module.UserModule),
				data: {
					title: 'labels.users',
					aclFeatures: ['users.section']
				}

			},
			{
				path: 'rolefeatures',
				loadChildren: () => import('./content/pages/role-features/role-features.module').then(module => module.RoleFeaturesModule),
				data: {
					types: ['admin'],
					aclFeatures: ['users.section']

				},
			},
			{
				path: 'conf',
				loadChildren: () => import('./content/pages/conf/conf.module').then(module => module.ConfModule),
				data: {
					types: ['admin'],
					aclFeatures: ['admin.config.section']
				}
			},
			{
				path: 'advanced',
				loadChildren: () => import('./content/pages/advanced/advanced.module').then(module => module.AdvancedModule),
				data: {
					types: ['admin'],
					aclFeatures: ['admin.config.section']
				}
			},
			{
				path: 'employee',
				loadChildren: () => import('./content/pages/employee/employee.module').then(module => module.EmployeeModule),
				data: {
					title: 'labels.employees',
					aclFeatures: ['employees.section']
				}
			},
			{
				path: 'owner',
				loadChildren: () => import('./content/pages/owner/owner.module').then(module => module.OwnerModule),
				data: {
					title: 'labels.owners',
					aclFeatures: ['company.owners.section']
				}
			},
			{
				path: 'building',
				loadChildren: () => import('./content/pages/building/building.module').then(module => module.BuildingModule),
				data: {
					title: 'labels.buildings',
					aclFeatures: ['company.buildings.section']
				}
			},
			{
				path: 'tool',
				loadChildren: () => import('./content/pages/tool/tool.module').then(module => module.ToolModule),
				data: {
					title: 'labels.tools',
					aclFeatures: ['company.tools.section']
				}
			},
			{
				path: 'doctemplate',
				loadChildren: () => import('./content/pages/doctemplate/doctemplate.module').then(module => module.DoctemplateModule),
				data: {
					title: 'labels.doctemplate',
					aclFeatures: ['company.doctemplate.section']
				}
			},
			{
				path: 'document',
				loadChildren: () => import('./content/pages/document/document.module').then(module => module.DocumentModule),
				data: {
					title: 'labels.documents',
					aclFeatures: ['company.documents.section']
				}
			},
			{
				path: 'doclibrary',
				loadChildren: () => import('./content/pages/doclibrary/doclibrary.module').then(module => module.DoclibraryModule),
				data: {
					types: ['admin'],
					aclFeatures: ['admin.doclibrary.section']
				}
			},
			{
				path: 'tender',
				loadChildren: () => import('./content/pages/tender/tender.module').then(module => module.TenderModule),
				data: {
					types: ['admin'],
					aclFeatures: ['admin.tenders.section']
				}
			},
			{
				path: 'project',
				loadChildren: () => import('./content/pages/project/project.module').then(module => module.ProjectModule),
				data: {
					types: ['admin', 'company'],
					aclFeatures: ['projects.section']
				}
			},
			{
				path: 'profile',
				loadChildren: () => import('./content/pages/profile/profile.module').then(module => module.ProfileModule),
				data: {
					types: ['company'],
					title: 'labels.profile'
				}
			},

			{
				path: 'unauthorized',
				loadChildren: () => import('./content/pages/unauthorized/unauthorized.module').then(m => m.UnauthorizedModule)
			},
			{ path: 'login', redirectTo: '/signin', pathMatch: 'full' },
		],
		canActivate: [AuthenticationGuardService],
		canActivateChild: [AuthenticationGuardService]
	},
	{
		path: '',
		component: AuthComponent,
		children: []
	}
];

@NgModule({
	imports: [RouterModule.forRoot(routes)],
	exports: [RouterModule]
})
export class AppRoutingModule { }
